export enum ExportKrameriusJob {
	EXPORT_JSON = 'EXPORT_JSON',
	EXPORT_TEI = 'EXPORT_TEI',
	EXPORT_CSV = 'EXPORT_CSV',
	EXPORT_ALTO = 'EXPORT_ALTO',
	EXPORT_TEXT = 'EXPORT_TEXT',
}
